<script setup>

</script>

<template>
  <svg id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <path d="M15.21,34.55H2.37l-1.95-1.93V12.38l1.93-1.93h12.86l1.93,1.93v20.23l-1.93,1.93ZM15.65,31.99h0,0ZM3.6,31.55h10.37l.18-.18V13.63l-.18-.18H3.6l-.18.18v17.74l.18.18Z" fill="currentcolor"/>
    <rect x="7.32" y="19.24" width="3" height="6.21" fill="currentcolor"/>
    <rect x="21.04" y="19.37" width="3" height="5.95" fill="currentcolor"/>
    <rect x="34.75" y="19.15" width="3" height="6.38" fill="currentcolor"/>
    <path d="M28.93,34.55h-12.84l-1.95-1.93V12.38l1.93-1.93h12.86l1.93,1.93v20.23l-1.93,1.93ZM29.36,31.99h0,0ZM17.32,31.55h10.37l.18-.18V13.63l-.18-.18h-10.37l-.18.18v17.74l.18.18Z" fill="currentcolor"/>
    <path d="M42.64,34.55h-12.84l-1.95-1.93V12.38l1.93-1.93h12.86l1.93,1.93v20.23l-1.93,1.93ZM43.08,31.99h0,0ZM31.03,31.55h10.37l.18-.18V13.63l-.18-.18h-10.37l-.18.18v17.74l.18.18Z" fill="currentcolor"/>
  </svg>
</template>

<style scoped lang="scss">

</style>